import { Dialog } from "@mui/material";
import styled, { css } from "styled-components";
import { COLORS } from "../utils";

const sharedStyles = css`
  display: flex;
  height: 42px;
  width: 100%;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  padding: 0 14px;
  color: ${(props: any) => (props.disabled ? "#a0a0a0" : "#333")};
  font-size: 16px;
  font-family: Inter;
  :focus {
    border: none;
    -webkit-appearance: none;
    outline: none;
  }
  ::placeholder {
    color: #a3a3a6;
  }
`;

export const DialogContainer = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 90vw;
  padding: 20px;
  box-sizing: border-box;
  font-family: Inter;
  gap: 12px;

  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.gray500};
    text-align: flex-start;
    width: 100%;
    margin-left: 10px;
  }
  .center {
    align-self: center;
  }
  .subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.gray300};
  }
  .error-text {
    margin-top: 5px;
    font-size: 12px;
    color: red;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  gap: 10px;

  .icon-wrapper {
    background-color: #d1fadf;
    border-radius: 50%;
    border: 8px solid #ecfdf3;
    padding: 8px;
    font-size: 20px;
  }
  .exit {
    color: #667085;
    :hover {
      cursor: pointer;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
    margin: 8px 0px;
  }
  .radio {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: 400;
      color: ${COLORS.gray500};
    }
  }
  .error-text {
    font-size: 12px;
    color: red;
  }
  .field-name {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
    padding-bottom: 8px;

    span {
      color: red;
    }
  }
  .upload {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`;

interface InputContainerProps {
  isFocused?: boolean;
  disabled?: boolean;
  borderColor?: string;
}

export const InputContainer = styled.div<InputContainerProps>`
  display: flex;
  height: 44px;
  width: 100%;
  border-radius: 8px;
  background-color: ${(props: any) =>
    props.disabled ? "rgba(0,0,0,0.08)" : "#ffffff"};
  border-width: ${(props: any) => (props.isFocused ? 2 : 1)}px;
  border-style: solid;
  border-color: ${(props: any) =>
    props.isFocused ? "#4a76fb" : props.borderColor ?? "#C4C4C4"};
  transition: border-color 0.2s ease-in;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  overflow: hidden;
`;

export const Input = styled.input`
  ${sharedStyles}
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
  font-family: Inter;

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
  }

  p {
    font-size: 14px;
    color: ${COLORS.gray500};
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
`;

export const LabelErrorContainer = styled.div`
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
`;
